module.exports = __webpack_public_path__ + "static/media/22.01d0f529.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/22.jpg
// module id = 283
// module chunks = 0